/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Btn_ShareInputs */

const tr_landing_telegram_mock_btn_share = /** @type {(inputs: Landing_Telegram_Mock_Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paylaş`)
};

const en_landing_telegram_mock_btn_share = /** @type {(inputs: Landing_Telegram_Mock_Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share`)
};

const de_landing_telegram_mock_btn_share = /** @type {(inputs: Landing_Telegram_Mock_Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen`)
};

const ru_landing_telegram_mock_btn_share = /** @type {(inputs: Landing_Telegram_Mock_Btn_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поделиться`)
};

/**
* | output |
* | --- |
* | "Share" |
*
* @param {Landing_Telegram_Mock_Btn_ShareInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_btn_share = /** @type {((inputs?: Landing_Telegram_Mock_Btn_ShareInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Btn_ShareInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_btn_share(inputs)
	if (locale === "de") return de_landing_telegram_mock_btn_share(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_btn_share(inputs)
	return tr_landing_telegram_mock_btn_share(inputs)
});